import { SectionHeading, SectionLabel } from "./Section";

const steps = [
    { label: "Login", detail: "Single sign-on for the team." },
    { label: "Role Detected", detail: "Sales, HR, Ops, Finance…" },
    { label: "Employee Dashboard", detail: "Role-specific workspace." },
    { label: "Data Submitted", detail: "Structured updates flow in." },
    { label: "Agent Analyzes", detail: "AI observes and enriches." },
    { label: "CEO Sees Decision Card", detail: "One click. One direction." },
];

export default function RoleFlow() {
    return (
        <section id="flow" data-testid="flow-section" className="relative py-28 sm:py-36">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="reveal max-w-3xl">
                    <SectionLabel num="05">Role-Based App Flow</SectionLabel>
                    <SectionHeading className="mt-6">
                        Every employee gets the right workspace.{" "}
                        <span className="italic font-normal">
                            The CEO gets the decision.
                        </span>
                    </SectionHeading>
                </div>

                <div className="reveal mt-16 relative">
                    {/* rail */}
                    <div className="hidden lg:block absolute left-0 right-0 top-8 h-px bg-gradient-to-r from-transparent via-neutral-200 to-transparent" />

                    <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4 relative">
                        {steps.map((s, i) => (
                            <li
                                key={s.label}
                                data-testid={`flow-step-${i + 1}`}
                                className="relative"
                            >
                                <div className="hidden lg:flex items-center justify-center h-16 pointer-events-none">
                                    <div className="relative">
                                        <span className="block h-4 w-4 rounded-full bg-white border border-violet-300 shadow-[0_0_0_6px_rgba(139,92,246,0.08)]" />
                                        <span className="absolute inset-1 rounded-full bg-violet-500 anim-pulse-glow" />
                                    </div>
                                </div>

                                <div className="glass rounded-2xl p-5 h-full">
                                    <div className="flex items-center justify-between">
                                        <span className="font-mono-alt text-[11px] text-violet-500">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        {i < steps.length - 1 && (
                                            <span className="text-neutral-300 sm:hidden">→</span>
                                        )}
                                    </div>
                                    <div className="mt-3 font-display text-[18px] sm:text-[20px] font-medium tracking-tight text-black">
                                        {s.label}
                                    </div>
                                    <div className="mt-1.5 text-[13px] text-neutral-500 leading-relaxed">
                                        {s.detail}
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
}
